import logoSalesforce from "../../../../../images/logos/logo_salesforce.svg";
import ChannelCard from "../../Utilities/ChannelCard";
import useSalesforceSetup from "./useSalesforceSetup";

export default function SalesforceProvider() {
    const {initiateSalesforceSetup} = useSalesforceSetup({
        callbackPath: '/salesforce/accounts',
        testCallbackPath: '/salesforce-test/accounts'
    })

    return (
        <ChannelCard
            icon={logoSalesforce}
            label={'Salesforce'}
            description={'Send personalized winback messages or respond to support cases'}
            onClick={initiateSalesforceSetup}
            allowTestInstanceConnection={true}
        />
    )
}